import { useEffect, useState } from "react";
import { useLanguage } from '../hooks/LanguageContext';
import { getHexSizes } from '../../static/js/DataRequestFunctions';
import locale from '../locales/HexSizeSwitcher.locale';
import '../../assets/css/MenuPanel.css';

const DEFAULT_HEX_SIZE = 8;

const HexSizeSwitcher = ({ regionId, hexSize, setHexSize }) => {
    const { language } = useLanguage();
    const t = locale[language];
    
    const [availableSizes, setAvailableSizes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log('HexSizeSwitcher regionId:', regionId)
        if (!regionId) {
            setAvailableSizes([DEFAULT_HEX_SIZE]);
            setHexSize(DEFAULT_HEX_SIZE);
            return;
        }

        setLoading(true);
        setError(null);

        getHexSizes(regionId)
            .then(sizes => {
                if (!Array.isArray(sizes) || sizes.length === 0) {
                    throw new Error(t.errors.emptySizes);
                }

                setAvailableSizes(sizes);

                if (!hexSize || !sizes.includes(hexSize)) {
                    setHexSize(sizes[sizes.length - 1]);
                }
            })
            .catch(err => {
                console.warn(t.errors.loadFailed, err);

                setError(t.errors.loadFailed);
                setAvailableSizes([DEFAULT_HEX_SIZE]);
                setHexSize(DEFAULT_HEX_SIZE);
            })
            .finally(() => setLoading(false));
    }, [regionId, t.errors.emptySizes, t.errors.loadFailed]);

    /* ================= UI ================= */

    if (loading) {
        return (
            <div className="slider-container">
                <div className="section-title">{t.title}</div>
                <div className="product-label">{t.loading}</div>
            </div>
        );
    }

    if (availableSizes.length === 1) {
        return (
            <div className="slider-container">
                <div className="section-title">{t.title}</div>
                <input
                    type="range"
                    min={0}
                    max={0}
                    value={0}
                    className="slider"
                    disabled
                    style={{ opacity: 0.5 }}
                    title={t.tooltip.disabled}
                />
                <div className="product-label">
                    {availableSizes[0]}
                    {error && (
                        <span style={{ fontSize: "0.75em", opacity: 0.6, marginLeft: 8 }} 
                              title={error}>
                            ({t.default})
                        </span>
                    )}
                </div>
            </div>
        );
    }

    const currentIndex = Math.max(0, availableSizes.indexOf(hexSize));

    return (
        <div className="slider-container">
            <div className="section-title">{t.title}</div>

            <input
                type="range"
                min={0}
                max={availableSizes.length - 1}
                step={1}
                value={currentIndex}
                className="slider"
                onChange={e => setHexSize(availableSizes[Number(e.target.value)])}
                title={t.tooltip.select}
            />

            <div className="product-label">
                {hexSize}
                <span style={{ fontSize: "0.8em", opacity: 0.7, marginLeft: "8px" }}>
                    ({t.available}: {availableSizes.join(", ")})
                </span>
            </div>
            
            {error && (
                <div style={{ fontSize: "0.8em", color: "#f44336", marginTop: "4px" }}>
                    ⚠️ {error}
                </div>
            )}
        </div>
    );
};

export default HexSizeSwitcher;